import { BiRefresh } from 'react-icons/bi';
import { useResendInvitationMutation } from '../slices/userApiSlice';

type ResendInviteLinkProps = {
  email: string;
  extraClassName?: string;
};
const ResendInviteLink = ({ email, extraClassName }: ResendInviteLinkProps) => {
  const [resend, { isLoading }] = useResendInvitationMutation();
  return (
    <span
      className={`items-center flex btn red text-center m-auto ${extraClassName ?? ''}`}
      onClick={() => resend({ email })}
    >
      <BiRefresh
        color='white'
        className={`text-xl mr-2 ${isLoading ? 'animate-spin' : 'text-xl'}`}
      />
      Resend to User
    </span>
  );
};

export default ResendInviteLink;
